<div class="card">
  <h2>未完成的測試</h2>

  <table class="styled-table">
    <thead>
      <tr>
        <th>參加者識別碼</th>
        <th>測試序列</th>
        <th>日期</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let progress of allOngoingExperiments">
        <td>{{ progress.participantIdentifier }}</td>
        <td>{{ progress.trialSequenceNumber || 'N/A' }}</td>
        <td>{{ getLocalUpdateTime(progress.updateTimeUTC) }}</td>
        <td>
          <div class="button-group">
            <button
              class="button secondary"
              (click)="continueExperiment(progress.participantIdentifier)"
            >
              繼續測試
            </button>
            <button
              class="button warn"
              (click)="deleteExperiment(progress.participantIdentifier)"
            >
              刪除
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
